import type { PricingProps } from "@/types/sections/pricing";

export interface Props {
  data: PricingProps;
}

export const paddingMap = {
  none: "",
  sm: "py-10 px-4",
  md: "py-16 px-6",
  lg: "py-20 px-6",
  xl: "py-28 px-8",
  "2xl": "py-32 px-12",
};
